var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"data-external":"button-primary"},on:{"click":_vm.onClick}},[_c('UCIcon',{staticClass:"icon",attrs:{"icon":_vm.icon}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }